const INITIAL_STATE = { registro: {}, modoTela: 'lista', lista: [], listaRacaTipo: [] };

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'RACA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};
        case 'RACA_LISTADO':
            return { ...state, modoTela: 'lista', lista: action.payload.data };
		case 'RACA_TIPO_SELECT_LISTADO':
            return { ...state, listaRacaTipo: action.payload.data };
        default:
            return state;
    }
}
